// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCardPaymentButton_root__9M+59","text":"PlasmicCardPaymentButton_text__+ZWbu"};